// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonTransparent_btn__3jBaG"};